import React from "react";
import { motion } from "framer-motion";

const containerVariants = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.12 },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 18 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.4, ease: "easeOut" },
    },
};

/**
 * StaggerList — lista con efecto cascada al entrar en el viewport
 * @param {Array}    items        - array de datos a renderizar
 * @param {function} renderItem   - (item, index) => ReactNode
 * @param {string}   className    - clases del contenedor externo
 * @param {number}   threshold    - fracción visible para activar (default 0.1)
 */
export default function StaggerList({
    items = [],
    renderItem,
    className = "",
    threshold = 0.1,
}) {
    return (
        <motion.div
            className={className}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: threshold }}
        >
            {items.map((item, i) => (
                <motion.div key={i} variants={itemVariants}>
                    {renderItem(item, i)}
                </motion.div>
            ))}
        </motion.div>
    );
}
